import { AddressEnvMap, SupportedChainId } from "./chains.base";
export const SUPPORTED_CHAIN_IDS_MAP: AddressEnvMap = {
  // [SupportedChainId.ZKMAINNET]: SupportedChainId.ZKMAINNET,

  [SupportedChainId.BLAST_TEST]: SupportedChainId.BLAST_TEST,
  // [SupportedChainId.ARB_TEST]: SupportedChainId.ARB_TEST,
};

export const SUPPORTED_CHAIN_IDS: SupportedChainId[] = [
  // SupportedChainId.ZKMAINNET,

  SupportedChainId.BLAST_TEST,
  // SupportedChainId.ARB_TEST,
];
